<template>
  <h5 v-if="display" class="mb-1 fs-7 text-gray-700 mb-2">Страхователь</h5>
  <div v-if="display" class="podft-list p-4 rounded border mb-3">
    <div v-if="display.entrepreneur" class="podft-list__item">
      <div class="text-gray-600 fs-7"> Наименование ИП:
        <span class="text-gray-800 float-end">{{ display.entrepreneur }}</span>
      </div>
    </div>
    <div class="podft-list__item">
      <div class="text-gray-600 fs-7"> {{ display.person ? 'ФИО' : '' }}
        <span class="text-gray-800" :class="display.person ? 'float-end' : ''">{{ display.title }}</span>
      </div>
    </div>
    <div class="podft-list__item">
      <div class="text-gray-600 fs-7"> {{ display.person ? 'ИИН' : 'БИН' }}
        <span class="text-gray-800" :class="display.person ? 'float-end' : ''">{{ display.iin }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PolicyInsurer',
  props: {
    insurer: null
  },
  computed: {
    display() {
      return this.normalizeParty(this.insurer)
    }
  },
  methods: {
    normalizeParty(party) {
      if (!party) return null
      if (!party.client) return party

      const client = party.client
      const filter = party.filter ?? {}
      const title = client.title
        ?? [client.surname, client.name, client.patronymic].filter(Boolean).join(' ').trim()

      return {
        person: filter.person ?? true,
        title: title || null,
        iin: client.iin,
        entrepreneur: party.entrepreneur
      }
    }
  }
}
</script>

<style scoped>

</style>
